import { render } from "./ProfessionForeignAmountsView.vue?vue&type=template&id=300a9b32&scoped=true"
import script from "./ProfessionForeignAmountsView.vue?vue&type=script&lang=js"
export * from "./ProfessionForeignAmountsView.vue?vue&type=script&lang=js"

import "./ProfessionForeignAmountsView.vue?vue&type=style&index=0&id=300a9b32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-300a9b32"]])

export default __exports__